import type { FContentTemplateProps } from '@/components/templates/FContentTemplate.vue';

export function mapApiDataToPrivacy(
  privacyRawData: StrapiResponseData<PrivacyPolicyContentType> | undefined
): FContentTemplateProps {
  return {
    content: privacyRawData?.attributes?.content ?? '',
    lastUpdate: privacyRawData?.attributes?.updatedAt,
    title: '',
  };
}
